import {config as configLocal} from '_premierworld/js/config';


/** Deep merge in plain javascript
 * 
 * 
 */
let mergeDeep = function(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
  
    if (isObject(target) && isObject(source)) {
      for (const key in source) {
        if (isObject(source[key])) {
          if (!target[key]) Object.assign(target, { [key]: {} });
          mergeDeep(target[key], source[key]);
        } else {
          Object.assign(target, { [key]: source[key] });
        }
      }
    }
  
    return mergeDeep(target, ...sources);
}

/** Test if the input element is an Object
 * 
 * @param mixed a (the input element to test)
 * 
 */
let isObject = function(a) {
    return (!!a) && (a.constructor === Object);
}

let config = mergeDeep({
    siteUrl: document.location.origin + "/",
    apiUrl: document.location.origin + "/api/",
    socketIO: 'https://' + document.location.host.split(":")[0] + ":3200",
    imagesUrl: document.location.origin + "/images/",
    languageCode: null,
    brandName: 'Tradeholding',
    globalLanguage: 'en',
    language: {
        LanguageFile: {
            ajax: {},
            quill: {}
        }
    },
    datatable: {
        responsive: {
            icon: 'fal',
            openIcon: 'fa-plus-square',
            closeIcon: 'fa-minus-square'
        }
    },
    notifications: {
        timer: 8500
    },
    inited: false,
    places: {
        appId: 'plCND6ZLO074',
        apiKey: 'aa876adf1cca4862aede7801a9c254d1',
    }
}, configLocal);

export {config};